import { Type } from '@angular/core';
import { FormField } from './form-details.model';
/** ComponentItem */
export class ComponentItem {
  public constructor (
    public component: Type<any>,
    public formField?: FormField,
  ) {}
}
